import { render, staticRenderFns } from "./categ_node_product.vue?vue&type=template&id=ca06b8d0&scoped=true&"
import script from "./categ_node_product.vue?vue&type=script&lang=js&"
export * from "./categ_node_product.vue?vue&type=script&lang=js&"
import style0 from "./categ_node_product.vue?vue&type=style&index=0&id=ca06b8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca06b8d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca06b8d0')) {
      api.createRecord('ca06b8d0', component.options)
    } else {
      api.reload('ca06b8d0', component.options)
    }
    module.hot.accept("./categ_node_product.vue?vue&type=template&id=ca06b8d0&scoped=true&", function () {
      api.rerender('ca06b8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/sub/categ_node_product.vue"
export default component.exports